import { useCallback, useEffect, useState } from "react";
import { listActiveCampuses } from "../api/campusesApi.js";

export default function useCampuses() {
  const [campuses, setCampuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await listActiveCampuses();
      setCampuses(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Failed to fetch campuses:", e);
      setError(e);
      setCampuses([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { campuses, loading, error, refetch };
}
